import Box from '@mui/joy/Box';

import { useState } from 'react';

import HubSearchBox from '@/components/Hub/HubSearchBox';
import TagFilterPane from '@/components/Hub/TagFilterPane';
import HubRepoList from '@/components/HubRepoList';
import { useAuth } from '@/hooks/useAuth/useAuth';
import { usePermissions } from '@/hooks/usePermissions';
import { useSelectedTenant } from '@/hooks/useSwr';

import { PlaygroundCreatePromptButton } from '../Prompts/components/PlaygroundButton';

const Hub = () => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const { authed } = useAuth();
  const { data: selectedTenant } = useSelectedTenant();
  const hasHandle = selectedTenant?.tenant_handle;
  const { authorize } = usePermissions();

  const state: 'no-access' | 'no-tenant' | 'needs-handle' | 'full-access' =
    (() => {
      if (!authed) return 'no-access';
      if (!selectedTenant) return 'no-tenant';
      if (!hasHandle) return 'needs-handle';
      return 'full-access';
    })();

  return (
    <div className="flex flex-1 items-start gap-2">
      <Box flexBasis={0} flexGrow={1} />
      <Box
        flexBasis={768}
        flexGrow={0}
        display="flex"
        flexDirection={'column'}
        gap={2}
      >
        <div className="mt-16">
          <div className="flex flex-col gap-4 text-center">
            <span className="text-4xl font-medium text-[#1C3C3C] dark:text-white">
              LangChain Hub
            </span>
            <span>Explore and contribute prompts to the community hub</span>
          </div>
          <HubSearchBox inputSx={{ height: 40 }} />
        </div>
        <HubRepoList tags={selectedTags} hasCommits={true} />
      </Box>
      <Box flexBasis={0} flexGrow={1} className="relative">
        {['full-access', 'needs-handle'].includes(state) &&
          authorize('prompts:create') && (
            <div className="absolute right-1 top-4">
              <PlaygroundCreatePromptButton />
            </div>
          )}
      </Box>
      <TagFilterPane
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        hasCommits={true}
      />
    </div>
  );
};

export default Hub;
